import { useState } from "react";
import { NavButton } from "./NavButton";
import type { Button, SlotProps } from "@mui/material";
import { Box, Menu } from "@mui/material";
import { Icon } from "@trimble/modus-cmx";

type MyDropdownButtonProps = {
  children?: (props: { onClose: () => void }) => React.ReactNode;
  title: string;
  slotProps?: {
    button?: SlotProps<typeof Button, object, object>;
    menu?: SlotProps<typeof Menu, object, object>;
  };
};

export default function MyDropdownButton(props: MyDropdownButtonProps) {
  const { children, title, slotProps } = props;

  const [anchorEl, setAnchorEl] = useState<null | Element>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <NavButton
        id="dropdown-button"
        aria-controls={open ? "dropdown-button" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={
          <Icon
            name="expand_more"
            style={{ transform: !open ? "rtl" : "rotateX(180deg)" }}
            key={open ? "expanded" : "collapsed"}
          />
        }
        {...slotProps?.button}
      >
        <Box
          component="span"
          sx={{
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Box>
      </NavButton>
      <Menu
        id="dropdown-button"
        slotProps={{
          paper: { sx: { borderRadius: 0, "& .MuiList-root": { py: 2 } } },
          list: { "aria-labelledby": "dropdown-button" },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        {...slotProps?.menu}
      >
        {children?.({ onClose: handleClose })}
      </Menu>
    </>
  );
}
